export default __webpack_public_path__ + "static/media/about2.02e127ea.png";